'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dGrouping$002dDescription$0024 from "./presto.types$-Grouping-Description$.js";
import * as $j_presto$002etypes$0024$002dGrouping$002dId$0024 from "./presto.types$-Grouping-Id$.js";
import * as $j_presto$002etypes$0024$002dGrouping$002dKind$0024 from "./presto.types$-Grouping-Kind$.js";
import * as $j_presto$002etypes$0024$002dGrouping$002dName$0024 from "./presto.types$-Grouping-Name$.js";
var $p;
/** @constructor */
function $c_Lpresto_Groupings$$anon$1(outer) {
  this.aXp = null;
  this.aXn = null;
  this.aXo = false;
  this.aXl = null;
  this.aXm = false;
  this.aXq = false;
  this.aXr = false;
  if ((outer === null)) {
    throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_NullPointerException__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_NullPointerException());
  }
  this.aXp = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
}
export { $c_Lpresto_Groupings$$anon$1 as $c_Lpresto_Groupings$$anon$1 };
$p = $c_Lpresto_Groupings$$anon$1.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_Groupings$$anon$1;
/** @constructor */
function $h_Lpresto_Groupings$$anon$1() {
}
export { $h_Lpresto_Groupings$$anon$1 as $h_Lpresto_Groupings$$anon$1 };
$h_Lpresto_Groupings$$anon$1.prototype = $p;
$p.a1 = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a);
});
$p.ac = (function() {
  return this.aXp;
});
$p.t = (function() {
  if ((!this.aXo)) {
    this.aXn = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("id", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("name", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("kind", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("description", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("global", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$())))));
    this.aXo = true;
  }
  return this.aXn;
});
$p.ad = (function() {
  if ((!this.aXm)) {
    this.aXl = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Encoder$$anon$24($j_presto$002etypes$0024$002dGrouping$002dId$0024.$m_Lpresto_types$GroupingId$().SA()), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dGrouping$002dName$0024.$m_Lpresto_types$GroupingName$().crz(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Encoder$$anon$24($j_presto$002etypes$0024$002dGrouping$002dKind$0024.$m_Lpresto_types$GroupingKind$().cHy()), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dGrouping$002dDescription$0024.$m_Lpresto_types$GroupingDescription$().cHx(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Encoder$().j0, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$())))));
    this.aXm = true;
  }
  return this.aXl;
});
$p.v = (function() {
  if ((!this.aXr)) {
    this.aXq = false;
    this.aXr = true;
  }
  return this.aXq;
});
$p.ab = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredEncoder__encodeProduct__O__Lio_circe_JsonObject(this, a);
});
var $d_Lpresto_Groupings$$anon$1 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_Groupings$$anon$1, "presto.Groupings$$anon$1", ({
  JU: 1,
  a: 1,
  j: 1,
  n: 1,
  o: 1,
  p: 1,
  d: 1
}));
export { $d_Lpresto_Groupings$$anon$1 as $d_Lpresto_Groupings$$anon$1 };
//# sourceMappingURL=presto.-Groupings$$anon$1.js.map
